import { Chip, TextField } from "@mui/material";
import { Box } from "@mui/system";
import MultipleSelect from "../MultipleSelect";
import SelectMenu from "../SelectMenu";
import TableFilterAcionts from "../TableFilterAcionts";

interface IProps {
  filter: IFilter;
  setFilter: (filter: IFilter) => void;
  handleSearch: (filter?: IFilter) => void;
}

interface IFilter {
  status: boolean;
  data: {
    name: string,
    uuid: string,
    status: string,
  }
}

const initFilterData: IFilter = {
  status: true,
  data: {
    name: "",
    uuid: "",
    status: "",
  }
};

export default function FilterForm({
  filter,
  setFilter,
  handleSearch,
}: IProps) {
  const handleChanges = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFilter({
      ...filter,
      data: {
        ...filter.data,
        [event.target.name]: event.target.value,
      },
    });
  };

  return (
    <Box>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 2 }}>
        <TextField
          label="Project Name"
          variant="standard"
          value={filter.data.name}
          name="name"
          onChange={handleChanges}
          sx={{ flex: "1 1 30%" }}
        />
        <TextField
          label="UUID"
          variant="standard"
          value={filter.data.uuid}
          name="uuid"
          onChange={handleChanges}
          sx={{ flex: "1 1 30%" }}
        />
        <SelectMenu
          label="Status"
          handleChange={({ target }) => {
            setFilter({
              ...filter,
              data: {
                ...filter.data,
                status: target.value,
              },
            });
          }}
          options={[
            { value: "", label: "Status" },
            { value: "Compiled", label: "Compiled" },
            { value: "Not Compiled", label: "Not Compiled" },
          ]}
          value={filter.data.status}
          sx={{ flex: "1 1 30%" }}
        />
      </Box>
      <TableFilterAcionts
        disableCancel={false}
        handleClearSearch={() => {
          setFilter(initFilterData);

          handleSearch(initFilterData);
        }}
        handleSearch={handleSearch}
      />
    </Box>
  );
}
